import React from 'react';
import { Switch, useLocation } from 'react-router-dom';

import { AppRoute } from './App/AppRoute';
import { Login } from './Login/Login';
import { ManagerLandingPage } from './Manager/ManagerLandingPage';

export const NonAuthedRoutes = () => {
  const search = useLocation().search;
  const managerAction = new URLSearchParams(search).get('action');
  const actionsTitles = {
    approve: 'Approve',
    reject: 'Reject',
    approvecancellation: 'Approve cancellation',
    rejectcancellation: 'Reject cancellation',
  };
  const actionAsKey = managerAction as keyof typeof actionsTitles;
  return (
    <Switch>
      <AppRoute title={actionsTitles[actionAsKey] ?? ''} path="/manager">
        <ManagerLandingPage />
      </AppRoute>
      <AppRoute title="Login">
        <Login />
      </AppRoute>
    </Switch>
  );
};
